var map = {
	"./Afname bodemvocht gehalte en daling (uitzakken) van grondwaterstand.png": 2862,
	"./Afname voorraad in oppervlaktewater buffers (bv. IJsselmeer).png": 7337,
	"./Algehele verslechtering waterkwaliteit door hogere concentraties verontreinigende stoffen, snellere opwarming en toenemende zuurstofarmoede van het dalende watervolume.png": 1153,
	"./Belemmeringen voor waterrecreatie (pleziervaart; sportvisserij; watersport; waterbeleving).png": 194,
	"./Beperking beladingsgraad beroepsscheepvaart door verminderde waterdiepte rivieren; belemmering door tijdelijke stuwen en minder sluisschuttingen.png": 7658,
	"./Beperking waterbeschikbaarheid voor beregening.png": 8790,
	"./Beperking waterbeschikbaarheid voor handhaven oppervlaktewaterpeil (peilbeheer).png": 7057,
	"./Beperking waterbeschikbaarheid voor verversing en circulatie (doorspoelen) regionaal watersysteem.png": 2907,
	"./Bermbranden.png": 6791,
	"./Brand openbaar en privaat groen in lommerrijke bebouwde omgeving.png": 6106,
	"./Breuken in riolering; kabels en leidingen (w.o. nutsvoorzieningen).png": 6284,
	"./Daling relatieve luchtvochtigheid.png": 9821,
	"./Druk op drinkwatervoorziening door moeten stoppen van waterinname op punten met onvoldoende waterkwaliteit.png": 8426,
	"./Gewasbranden.png": 9235,
	"./Gezondheidsproblemen (zwem)water door wateroverdraagbare ziekteverwekkers als pathogenen; blauwalgen en botulisme.png": 9657,
	"./Grootschalige bodemdaling door veenoxidatie en inklinking in klei- en laagveengebieden.png": 2963,
	"./Grootschalige bodemdaling door veenoxidatie in hoogveengebieden.png": 9414,
	"./Grotere waterdiepte bij overstroming.png": 4575,
	"./Gunstiger omstandigheden voor sommige insecten die ziektes verspreiden.png": 2066,
	"./Hoge (potentiele) verdamping.png": 4291,
	"./Lage afvoer Rijn, Maas (Schelde en Eems).png": 8460,
	"./Lagere gewasopbrengsten land- en tuinbouw.png": 218,
	"./Lokale ongelijkmatige zettingen door klink en krimp.png": 7090,
	"./Losse klinkers en tegels; ongelijkmatig wegdek.png": 978,
	"./Meer CO2 uitstoot vanuit veengebieden.png": 3887,
	"./Meer verspreiding van luchtgebonden ziekteverwekkers (bv. pollen; fijnstof; Q koorts; haren eikenprocessierups).png": 7827,
	"./Natuurbranden (heide; bos; duinen).png": 3046,
	"./Neerslagtekort en verhoogd waterverbruik in bovenstroomse buurlanden.png": 4859,
	"./Ontstaan van laagtes in terrein (waar kans op wateroverlast toeneemt).png": 5498,
	"./Onvoldoende water voor en uitdrogen van planten en bomen.png": 9803,
	"./Oplopend neerslagtekort.png": 7064,
	"./Overschrijding vergunning grondwateronttrekking tbv drinkwater.png": 4919,
	"./Productieverlies door verminderde beschikbaarheid proces- en koelwater industrie.png": 3251,
	"./Scheefstanddroogvallen van drijvende woningen.png": 3733,
	"./Stankoverlast door droogval stankafsluiters rioolputten.png": 7839,
	"./Stankoverlast oppervlaktewater in leefomgeving.png": 6792,
	"./Sterfte en verlies biodiversiteit van watergebonden vegetatie en diersoorten (bv. vissterfte).png": 3523,
	"./Sterfte van dieren in natuurgebieden door gebrek aan voedsel.png": 9433,
	"./Sterfte van planten en bomen en verlies biodiversiteit in natuurgebieden met vochtminnende ecosystemen.png": 9242,
	"./Sterfte van planten en bomen in openbaar groen en in particuliere tuinen.png": 1476,
	"./Toename verzilting van watergangen door opwellend brak grondwater.png": 4297,
	"./Uitdroging van dijk- en kadelichamen; en daardoor verhoogde kans op doorbreken.png": 1560,
	"./Uitdroging van zoetwaterlens in de bodem en optrekken brak grondwater naar wortelzone.png": 716,
	"./Verminderde productie energiecentrales door tekort koelwater.png": 4014,
	"./Verstopping drainagebuizen met ijzeroxidatie a.g.v. droogval.png": 5258,
	"./Verzakking gebouwen door rot van houten (paal)funderingen; scheefstand en scheurvorming.png": 649,
	"./Verzakking taluds van wegen en spoorwegen.png": 7710,
	"./Verzakking van fundering van gebouwen en constructies; scheefstand en scheurvorming.png": 7835,
	"./Verzilting innamepunten voor zoetwater langs rivieren door stroomopwaartse indringing zeewater.png": 8228,
	"./Verzuring van bodem.png": 6654,
	"./Weinig neerslag.png": 1317,
	"./droogval beken; vennen en overige door neerslag gevoede waterpartijen.png": 2254,
	"./toename van hitte in leefomgeving door afname transpiratie van groen.png": 161
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2237;